export default __webpack_public_path__ + "static/media/modal-close.b444ca2f.svg";